// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let AuthenticatedComponentRelay = require("./AuthenticatedComponentRelay.bs.js");

function RequireAuthenticatedClient(props) {
  let children = props.children;
  return JsxRuntime.jsx(AuthenticatedComponentRelay.make, {
    requiredUserRole: "client",
    renderWrappedComponent: () => children
  });
}

let make = RequireAuthenticatedClient;

exports.make = make;
/* react/jsx-runtime Not a pure module */
